import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import BarChartIcon from '@material-ui/icons/BarChart';

const Heading: FC = () => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item>
        <BarChartIcon color="primary" />
      </Grid>
      <Grid item>
        <Typography variant="subtitle2">{t('groups:contentReport')}</Typography>
      </Grid>
    </Grid>
  );
};

export default Heading;
